module.exports = require("@pb/kit-component-state-button");